import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';

@Component({
    templateUrl: './access-denied.component.html',
    styleUrls: ['./access-denied.component.scss'],
})
export class AccessDeniedComponent implements OnInit {
    portal: string = '';
    permissions: string[] = [];
    isInitialNav = false;

    constructor(
        private route: ActivatedRoute,
        private location: Location,
        private router: Router
    ) {}

    ngOnInit() {
        this.route.data.pipe(take(1)).subscribe(data => {
            this.portal = data.portal || '';
            this.permissions = data.permissions || [];
        });

        this.route.queryParams.pipe(take(1)).subscribe(params => {
            if (params['portal']) {
                this.portal = params['portal'];
            }
            if (params['permissions']) {
                this.permissions = params['permissions'].split(',');
            }
            this.isInitialNav = params['initial'] === '1';
        });
    }

    goBack(): void {
        if (this.isInitialNav) {
            this.router.navigateByUrl('/colaborador');
            return;
        }
        this.location.back();
    }

    /**
     * Verifica se o acesso foi negado devido ao portal
     */
    get isPortalDenied(): boolean {
        return !!this.portal;
    }

    /**
     * Verifica se o acesso foi negado devido a permissões
     */
    get isPermissionDenied(): boolean {
        return this.permissions.length > 0;
    }

    /**
     * Retorna mensagem personalizada sobre o motivo do acesso negado
     */
    get accessDeniedReason(): string {
        if (this.isPortalDenied && this.isPermissionDenied) {
            return `Você não tem acesso ao portal "${this.portal}" e também não possui as permissões necessárias para acessar esta funcionalidade.`;
        } else if (this.isPortalDenied) {
            return `Você não tem acesso ao portal "${this.portal}".`;
        } else if (this.isPermissionDenied) {
            return `Você não possui as permissões necessárias para acessar esta funcionalidade.`;
        } else {
            return 'Você não possui permissão para acessar esta funcionalidade.';
        }
    }
}
